// Dependencies
require("modaal");

// Styles
require("./info-1-1.scss");

// jQuery
// 
// Must be instanciated before requiring
// jquery-validation
//
var $ = jQuery = require('jquery');

//Initialize Lightbox
$('.js-info-location').modaal({
    type: 'image',
    hide_close: true
});

//Unbind modaal under 700px
if ($(window).width() < 700) {
    $('.js-info-location').unbind();
}

$('.js-focus-form').click(function () {
    $('html, body').animate({
        scrollTop: $("#formReservation").offset().top - 180
    }, 750)
    .promise()
    .done(function () {
        $('.formulaire-1-1').find('.form-control').first().focus();
    });
});

$('.js-reservation-form').click(function () {
    var reservationUrl = $(this).data("reservationUrl")
    if (reservationUrl) {
        window.open(reservationUrl);
    } else {
        console.warn("No reservation url.")
    }
});


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/info-1/view-1/index.js
// module id = 204
// module chunks = 0